// BUILD-046 section B (Owner direction of 2026-10-21): the searchable "Assigned to" control on the toolbar (Company, Team and Assigned by Me). It opens the existing picker (AssigneeFilterPicker) in a popover, so it reads and writes
// the existing per-view filter state. The picker is no longer inside the Filter panel.
import { PopoverButton } from './DropdownMenu';
import { AssigneeFilterPicker } from './AssigneeFilterPicker';
import type { AssigneePickerControl } from './AssigneeFilterPicker';
import { ASSIGNEE_FILTER_LABEL, assigneeFilterActive } from './assigneeFilterModel';

const PERSON_ICON = (
  <svg aria-hidden="true" focusable="false" viewBox="0 0 20 20" className="h-4 w-4 text-gray-600" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
    <circle cx="10" cy="7" r="3" />
    <path d="M4 16c.8-3 3.2-4.5 6-4.5s5.2 1.5 6 4.5" />
  </svg>
);

export function AssigneeToolbarButton({ picker }: { picker: AssigneePickerControl }) {
  const active = assigneeFilterActive(picker.filter);
  return (
    <PopoverButton testId="toolbar-assignee" buttonText={ASSIGNEE_FILTER_LABEL} ariaLabel={active ? ASSIGNEE_FILTER_LABEL + ", 1 active" : ASSIGNEE_FILTER_LABEL} panelLabel={"Filter by " + ASSIGNEE_FILTER_LABEL} icon={PERSON_ICON} active={active} align="left">
      <AssigneeFilterPicker {...picker} />
    </PopoverButton>
  );
}

